import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry only in production (lazy-loaded to avoid dev-time module duplication)
if (import.meta.env.PROD) {
  import("./lib/sentry").then(({ initSentry }) => initSentry());
}

createRoot(document.getElementById("root")!).render(<App />);
